import gql from 'graphql-tag';

const USER_SUBSCRIPTION_DEACTIVATE = gql`
mutation subscriptionPlanDeactivate ($userId: ID!) {
    subscriptionPlanDeactivate (userId: $userId)
}
`;

export default USER_SUBSCRIPTION_DEACTIVATE;